/* =========================================================================
   ENDEX GROUP — endex-depth.js | Scroll + 3D for the pages beyond the homepage
   SHOP GRID   product images open with a small cell cascade as they arrive;
               cards stand up out of a backward lean as you scroll (every
               device), and tilt toward the cursor with a sheen on desktop.
   PRODUCT     "Inspection": corner brackets + an orange scan line when the
               page opens, a cell wipe when you change photos, a live frame
               readout, spec values scramble in. Desktop: 3D tilt + crosshair.
   EVENTS      A radar above the list. Real upcoming events are blips - nearer
               the centre is sooner, position round the dial is time of day.
               When the sweep passes a blip, that event's row lights up.
   404         The mark as a solid 3D object drifting apart over static. It
               tilts toward the cursor or finger and snaps back together when
               you reach for "Back to home".
   Runs after endex-fx.js. Reduced motion or no GSAP: nothing runs and the
   pages stay exactly as they are.
   ========================================================================= */
(function(){
  'use strict';
  var html=document.documentElement;
  var REDUCE=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE=window.matchMedia&&matchMedia('(hover: hover) and (pointer: fine)').matches;
  var SIG=(window.EndexFXConfig&&window.EndexFXConfig.sig)||'#FF5A1F';
  var DPR=Math.min(window.devicePixelRatio||1,FINE?2:1.5);
  var $=function(s,r){return (r||document).querySelector(s);};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  var clamp=function(v,a,b){return v<a?a:v>b?b:v;};
  var E='cubic-bezier(.19,1,.22,1)', E2='cubic-bezier(.65,0,.35,1)';
  function el(tag,cls,parent,htmlStr){var e=document.createElement(tag);if(cls)e.className=cls;if(htmlStr!=null)e.innerHTML=htmlStr;if(parent)parent.appendChild(e);return e;}
  function rgb(h){h=h.replace('#','');if(h.length===3)h=h.split('').map(function(c){return c+c;}).join('');var n=parseInt(h,16);return [n>>16&255,n>>8&255,n&255].join(',');}
  var SR=rgb(SIG);
  var GLYPHS='\u2593\u2592\u2591\u2588#/<>_-=+01';
  function scramble(node,text,dur){
    text=text==null?node.textContent:text; var t0=performance.now();
    (function f(now){var p=Math.min(1,(now-t0)/dur),rev=Math.floor(p*text.length*1.15),s='';
      for(var i=0;i<text.length;i++)s+=(i<rev||text[i]===' ')?text[i]:GLYPHS[(Math.random()*GLYPHS.length)|0];
      node.textContent=s; if(p<1)requestAnimationFrame(f);else node.textContent=text;})(t0);
  }
  function onceVisible(node,cb,margin){
    if(!('IntersectionObserver' in window)){cb();return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){io.disconnect();cb();}});},{rootMargin:margin||'0px 0px -8% 0px'});
    io.observe(node);
  }
  function whileVisible(node,start,stop){
    if(!('IntersectionObserver' in window)){start();return;}
    new IntersectionObserver(function(es){es.forEach(function(e){e.isIntersecting?start():stop();});},{rootMargin:'80px'}).observe(node);
  }

  // Page intros wait for the page transition's arrival cascade, so they play in view rather than underneath it.
  var arrived=!!(window.EndexTx&&window.EndexTx.arriving);
  var txReady=new Promise(function(res){
    if(!arrived)return res();
    document.addEventListener('endex:tx-done',res,{once:true}); setTimeout(res,2600);
  });
  window.EndexTxReady=txReady;
  function afterTx(fn){return function(){var a=arguments;txReady.then(function(){fn.apply(null,a);});};}
  // endex-fx.js raises headline words on load, which a transition hides. Replay the ones on screen once it clears.
  function replayHeadlines(){
    if(!arrived)return;
    txReady.then(function(){
      $$('main h1, main h2, main .display').forEach(function(h){
        var r=h.getBoundingClientRect(); if(r.bottom<0||r.top>window.innerHeight)return;
        var w=$$('.fx-wm > .fx-w',h); if(!w.length)return;
        gsap.fromTo(w,{yPercent:110},{yPercent:0,duration:1.05,ease:'expo.out',stagger:.045,overwrite:true});
      });
    });
  }

  var CSS=
  /* shared cell overlay */
  '.fxd-cells{position:absolute;inset:0;z-index:4;display:grid;pointer-events:none}'+
  '.fxd-cells i{position:relative;background:#070706;margin:-.5px}'+
  '.fxd-cells i b{position:absolute;inset:0;background:'+SIG+';opacity:0}'+
  /* shop */
  '.fxd-glare{position:absolute;inset:0;z-index:3;pointer-events:none;opacity:0;transition:opacity .5s;'+
    'background:radial-gradient(circle at var(--gx,50%) var(--gy,50%),rgba(255,255,255,.22),rgba(255,255,255,0) 55%);mix-blend-mode:soft-light}'+
  '.card:hover .fxd-glare{opacity:1}'+
  /* product */
  '.fxd-insp{position:absolute;inset:0;z-index:5;pointer-events:none}'+
  '.fxd-insp .k{position:absolute;width:22px;height:22px;border:1px solid rgba(244,241,234,.8)}'+
  '.fxd-insp .k:nth-child(1){left:12px;top:12px;border-right:0;border-bottom:0}.fxd-insp .k:nth-child(2){right:12px;top:12px;border-left:0;border-bottom:0}'+
  '.fxd-insp .k:nth-child(3){left:12px;bottom:12px;border-right:0;border-top:0}.fxd-insp .k:nth-child(4){right:12px;bottom:12px;border-left:0;border-top:0}'+
  '.fxd-insp .scan{position:absolute;left:0;right:0;top:0;height:2px;background:'+SIG+';box-shadow:0 0 16px 2px rgba('+SR+',.55);opacity:0}'+
  '.fxd-insp .rd{position:absolute;left:14px;bottom:42px;font:500 10px/1.5 "JetBrains Mono",monospace;letter-spacing:.18em;text-transform:uppercase;color:rgba(244,241,234,.85);text-shadow:0 1px 6px rgba(0,0,0,.6)}'+
  '.fxd-insp .rd b{color:'+SIG+';font-weight:500}'+
  '.fxd-insp .xh,.fxd-insp .yh{position:absolute;background:rgba(244,241,234,.35);opacity:0;transition:opacity .3s}'+
  '.fxd-insp .xh{left:0;right:0;height:1px}.fxd-insp .yh{top:0;bottom:0;width:1px}'+
  '.fxd-insp .co{position:absolute;font:500 9px/1 "JetBrains Mono",monospace;letter-spacing:.14em;color:'+SIG+';opacity:0;transition:opacity .3s;white-space:nowrap}'+
  '.pdp__main.fxd-hover .xh,.pdp__main.fxd-hover .yh,.pdp__main.fxd-hover .co{opacity:1}'+
  /* events radar */
  '.fxd-radar{position:relative;margin-top:28px;border:1px solid rgba(191,179,154,.2);background:rgba(7,7,6,.35);aspect-ratio:1/1;max-width:420px}'+
  '.fxd-radar canvas{position:absolute;inset:0;width:100%;height:100%}'+
  '.fxd-radar .lg{position:absolute;left:12px;top:10px;right:12px;display:flex;justify-content:space-between;font:500 9px/1.4 "JetBrains Mono",monospace;letter-spacing:.2em;text-transform:uppercase;color:#BFB39A;pointer-events:none}'+
  '.fxd-radar .lg b{color:'+SIG+';font-weight:500}'+
  '.fxd-radar .ft{position:absolute;left:12px;bottom:10px;right:12px;font:500 9px/1.4 "JetBrains Mono",monospace;letter-spacing:.16em;text-transform:uppercase;color:rgba(191,179,154,.8);pointer-events:none}'+
  '@media(min-width:900px){.ev__head.fxd-has-radar{display:grid;grid-template-columns:1fr 340px;column-gap:48px;align-items:start}'+
    '.ev__head.fxd-has-radar>.fxd-radar{grid-column:2;grid-row:1 / span 6;margin-top:0;width:100%}.ev__head.fxd-has-radar>*:not(.fxd-radar){grid-column:1}}'+
  '.ev__row.fxd-ping{border-color:'+SIG+'!important;background:rgba('+SR+',.08)!important;transition:border-color .1s,background .1s}'+
  '.ev__row{will-change:transform}'+
  /* 404 */
  '.fxd-404{position:relative;overflow:hidden}'+
  '.fxd-404 .nz{position:absolute;inset:0;width:100%;height:100%;z-index:0;opacity:.14;pointer-events:none;image-rendering:pixelated}'+
  '.fxd-404>.wrap{position:relative;z-index:1}'+
  '.fxd-m3{width:min(240px,58vw);aspect-ratio:1;margin:0 auto 18px;perspective:700px;touch-action:pan-y;cursor:grab}'+
  '.fxd-m3 .rig{position:relative;width:100%;height:100%;transform-style:preserve-3d}'+
  '.fxd-m3 .g{position:absolute;inset:0;transform-style:preserve-3d}'+
  '.fxd-m3 svg{position:absolute;inset:0;width:100%;height:100%;overflow:visible}'+
  '.fxd-m3 .core{position:absolute;left:50%;top:50%;width:18.75%;height:18.75%;margin:-9.375% 0 0 -9.375%;transform-style:preserve-3d}'+
  '.fxd-m3 .core i{position:absolute;inset:0;background:#3a3833}'+
  '.fxd-m3 .core i:last-child{background:#fff}'+
  '.fxd-404 .fxd-sig{display:block;margin-top:10px;font:500 10px/1 "JetBrains Mono",monospace;letter-spacing:.24em;color:'+SIG+';text-transform:uppercase}';

  /* ======================================================= SHOP GRID */
  // A small cell cascade over a card image: the same idea as the page transition, in miniature.
  function cellReveal(host,cols,rows,originX,originY,cb){
    var g=el('div','fxd-cells',host); g.style.gridTemplateColumns='repeat('+cols+',1fr)'; g.style.gridTemplateRows='repeat('+rows+',1fr)';
    var cells=[],last=0;
    for(var y=0;y<rows;y++)for(var x=0;x<cols;x++){var c=el('i','',g,'<b></b>');c._d=Math.hypot(x+.5-originX*cols,y+.5-originY*rows);cells.push(c);}
    cells.forEach(function(c){
      var d=c._d*55; if(d>last)last=d;
      c.animate([{transform:'scale(1)'},{transform:'scale(1)',offset:.3},{transform:'scale(0)'}],{duration:520,delay:d,easing:E2,fill:'forwards'});
      c.firstChild.animate([{opacity:0},{opacity:.7,offset:.25},{opacity:0}],{duration:520,delay:d,fill:'forwards'});
    });
    setTimeout(function(){g.remove();cb&&cb();},last+560);
    return g;
  }
  function cellWipe(host,cols,rows,mid){
    // in: cells cover with an orange flash; out: they clear again. Used when a product photo changes.
    var g=el('div','fxd-cells',host); g.style.gridTemplateColumns='repeat('+cols+',1fr)'; g.style.gridTemplateRows='repeat('+rows+',1fr)';
    var cells=[],last=0;
    for(var y=0;y<rows;y++)for(var x=0;x<cols;x++){var c=el('i','',g,'<b></b>');c.style.transform='scale(0)';c._d=x+y;cells.push(c);}
    cells.forEach(function(c){
      var d=c._d*22; if(d>last)last=d;
      c.animate([{transform:'scale(0)'},{transform:'scale(1)',offset:.35},{transform:'scale(1)',offset:.6},{transform:'scale(0)'}],{duration:620,delay:d,easing:E2,fill:'forwards'});
      c.firstChild.animate([{opacity:1},{opacity:1,offset:.3},{opacity:0,offset:.5}],{duration:620,delay:d,fill:'forwards'});
    });
    if(mid)setTimeout(mid,300+last/2);
    setTimeout(function(){g.remove();},last+660);
  }

  function shop(){
    var cards=$$('main .card').filter(function(c){return !c.closest('.fx-own')&&$('.card__media',c);});
    if(!cards.length)return;
    cards.forEach(function(card,i){
      var media=$('.card__media',card); if(media._fxd)return; media._fxd=1;
      // Cover the image until the card is actually on screen, then open it cell by cell.
      var cover=el('div','fxd-cells',media); cover.style.cssText='display:block;background:#070706';
      onceVisible(card,afterTx(function(){
        cover.remove();
        cellReveal(media,4,5,(i%2)?1:0,0);
      }),'0px 0px -12% 0px');
      // Stand up out of a backward lean as it scrolls into view. The engine already fades the card itself in,
      // so the lean lives on the image block to stay out of its way.
      gsap.fromTo(media,{rotationX:16,transformPerspective:900,transformOrigin:'50% 100%',z:-40},
        {rotationX:0,z:0,ease:'none',scrollTrigger:{trigger:card,start:'top bottom',end:'top 58%',scrub:.4}});
      if(!FINE)return;
      var glare=el('span','fxd-glare',media);
      card.addEventListener('pointermove',function(e){
        var r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;
        gsap.to(card,{rotationY:(x-.5)*10,rotationX:(.5-y)*8,transformPerspective:900,duration:.6,ease:'power3.out',overwrite:'auto'});
        glare.style.setProperty('--gx',(x*100)+'%'); glare.style.setProperty('--gy',(y*100)+'%');
      });
      card.addEventListener('pointerleave',function(){gsap.to(card,{rotationY:0,rotationX:0,duration:.9,ease:'expo.out',overwrite:'auto'});});
    });
  }

  /* ======================================================= PRODUCT */
  function product(){
    var main=$('.pdp__main'); if(!main||main._fxd)return; main._fxd=1;
    var frames=$$('.pdp__frame',main), n=frames.length;
    var o=el('div','fxd-insp',main,'<i class="k"></i><i class="k"></i><i class="k"></i><i class="k"></i><span class="scan"></span><span class="xh"></span><span class="yh"></span><span class="co"></span><span class="rd"></span>');
    var scan=$('.scan',o), rd=$('.rd',o), xh=$('.xh',o), yh=$('.yh',o), co=$('.co',o), ks=$$('.k',o);
    var code=($('.pdp__code .tagpill')||{}).textContent||'';
    function idx(){for(var i=0;i<n;i++)if(frames[i].classList.contains('is-active'))return i;return 0;}
    function readout(){var i=idx();rd.innerHTML='<b>\u25B8</b> Inspect'+(code?' // '+code.trim():'')+'<br>Frame '+String(i+1).padStart(2,'0')+' / '+String(Math.max(1,n)).padStart(2,'0');}
    function sweep(){scan.animate([{transform:'translateY(0)',opacity:0},{opacity:1,offset:.08},{opacity:1,offset:.9},{transform:'translateY('+main.clientHeight+'px)',opacity:0}],{duration:1100,easing:'cubic-bezier(.45,0,.2,1)'});}
    // Opening: brackets snap on, the scan runs once, the readout scrambles in - after any page transition has cleared.
    ks.forEach(function(k){k.style.opacity=0;}); readout(); rd.style.opacity=0;
    txReady.then(function(){
      ks.forEach(function(k,i){k.animate([{transform:'scale(2.4)',opacity:0},{transform:'none',opacity:1}],{duration:520,delay:120+i*50,easing:E,fill:'both'});k.style.opacity='';});
      setTimeout(sweep,280);
      rd.style.opacity=''; rd.childNodes.forEach(function(c){if(c.nodeType===3)scramble(c,null,500);});
    });
    // Photo change: a cell wipe across the frame and the scan again.
    var last=idx();
    new MutationObserver(function(){var i=idx(); if(i===last)return; last=i; cellWipe(main,6,Math.round(6*main.clientHeight/main.clientWidth)); setTimeout(sweep,200); readout();})
      .observe(main,{subtree:true,attributes:true,attributeFilter:['class']});
    // Specs: values scramble in as they arrive.
    $$('.spec__v').forEach(function(v,i){var t=v.textContent;v.style.visibility='hidden';onceVisible(v,afterTx(function(){v.style.visibility='';setTimeout(function(){scramble(v,t,420);},i*90);}));});
    // Scroll: the photo settles from a slight push-in as you move down the page.
    var targets=frames.length?frames:$$('img',main);
    if(targets.length)gsap.fromTo(targets,{scale:1.08},{scale:1,ease:'none',scrollTrigger:{trigger:main,start:'top 80%',end:'bottom top',scrub:true}});
    if(!FINE)return;
    main.style.transformStyle='preserve-3d';
    main.addEventListener('pointerenter',function(){main.classList.add('fxd-hover');});
    main.addEventListener('pointermove',function(e){
      var r=main.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;
      gsap.to(main,{rotationY:(x-.5)*7,rotationX:(.5-y)*6,transformPerspective:1100,duration:.7,ease:'power3.out',overwrite:'auto'});
      xh.style.top=(y*100)+'%'; yh.style.left=(x*100)+'%';
      co.style.left=Math.min(x*100,82)+'%'; co.style.top=(y*100)+'%'; co.style.transform='translate(8px,-14px)';
      co.textContent='X '+x.toFixed(2)+'  Y '+y.toFixed(2);
    });
    main.addEventListener('pointerleave',function(){main.classList.remove('fxd-hover');gsap.to(main,{rotationY:0,rotationX:0,duration:1,ease:'expo.out',overwrite:'auto'});});
  }

  /* ======================================================= EVENTS RADAR */
  function events(){
    var root=$('[data-ev]'), head=root&&$('.ev__head',root); if(!head||head._fxd)return; head._fxd=1;
    var box=el('div','fxd-radar',head,'<canvas aria-hidden="true"></canvas><div class="lg"><span>Radar // next 30 days</span><b data-n>\u2014</b></div><div class="ft">Centre is now \u00b7 dial is time of day</div>');
    box.setAttribute('role','img'); box.setAttribute('aria-label','Radar of upcoming events');
    head.classList.add('fxd-has-radar');
    var cv=$('canvas',box), ctx=cv.getContext('2d'), blips=[], t0=performance.now(), on=false, raf=0, SPAN=30*864e5;
    function rows(){return $$('.ev__row',root);}
    fetch('https://otjigdwhbxxvcnygppkc.supabase.co/functions/v1/live/public').then(function(r){return r.json();}).then(function(d){
      var evs=d.events||[], now=Date.now();
      blips=evs.map(function(e,i){var s=Date.parse(e.starts_at),dt=Math.max(0,s-now),dd=new Date(s);
        return {i:i,live:!!e.live,r:e.live?0:clamp(.12+.84*(dt/SPAN),.12,.98),a:((dd.getHours()+dd.getMinutes()/60)/24)*Math.PI*2-Math.PI/2,hit:-9,far:dt>SPAN};}).filter(function(b){return !b.far;});
      var nEl=$('[data-n]',box); nEl.textContent=String(blips.length).padStart(2,'0')+' contact'+(blips.length===1?'':'s');
    }).catch(function(){});
    function draw(){
      var r=cv.getBoundingClientRect(),W=Math.round(r.width*DPR),H=Math.round(r.height*DPR);
      if(cv.width!==W||cv.height!==H){cv.width=W;cv.height=H;}
      var t=(performance.now()-t0)/1000,cx=W/2,cy=H/2+8*DPR,R=Math.min(W,H)*.4;
      ctx.clearRect(0,0,W,H);
      ctx.lineWidth=1*DPR; ctx.strokeStyle='rgba(191,179,154,.18)';
      [.33,.66,1].forEach(function(k){ctx.beginPath();ctx.arc(cx,cy,R*k,0,6.283);ctx.stroke();});
      ctx.beginPath();ctx.moveTo(cx-R,cy);ctx.lineTo(cx+R,cy);ctx.moveTo(cx,cy-R);ctx.lineTo(cx,cy+R);ctx.stroke();
      ctx.fillStyle='rgba(191,179,154,.7)';ctx.font='500 '+(8*DPR)+'px "JetBrains Mono",monospace';ctx.textAlign='center';
      [['00',0,-1],['06',1,0],['12',0,1],['18',-1,0]].forEach(function(q){ctx.fillText(q[0],cx+q[1]*(R+11*DPR),cy+q[2]*(R+11*DPR)+3*DPR);});
      ctx.textAlign='left';ctx.fillStyle='rgba(191,179,154,.45)';
      [['7D',7],['14D',14]].forEach(function(q){var rr=.12+.84*(q[1]/30);ctx.fillText(q[0],cx+3*DPR,cy-R*rr-3*DPR);});
      // the sweep
      var ang=(t*1.4)%(Math.PI*2)-Math.PI/2;
      if(ctx.createConicGradient){var g=ctx.createConicGradient(ang-1.1,cx,cy);g.addColorStop(0,'rgba('+SR+',0)');g.addColorStop(.175,'rgba('+SR+',.28)');g.addColorStop(.1751,'rgba('+SR+',0)');
        ctx.fillStyle=g;ctx.beginPath();ctx.moveTo(cx,cy);ctx.arc(cx,cy,R,ang-1.1,ang);ctx.closePath();ctx.fill();}
      ctx.strokeStyle='rgba('+SR+',.9)';ctx.beginPath();ctx.moveTo(cx,cy);ctx.lineTo(cx+Math.cos(ang)*R,cy+Math.sin(ang)*R);ctx.stroke();
      // blips light as the sweep passes, and ping their row
      var list=rows();
      blips.forEach(function(b){
        var bx=cx+Math.cos(b.a)*R*b.r,by=cy+Math.sin(b.a)*R*b.r;
        var d=((ang-b.a)%(Math.PI*2)+Math.PI*2)%(Math.PI*2);
        if((d<.09||b.live&&d<.2)&&t-b.hit>1){b.hit=t;var row=list[b.i];if(row){row.classList.add('fxd-ping');setTimeout(function(){row.classList.remove('fxd-ping');},420);}}
        var age=t-b.hit,al=b.live?.6+.4*Math.sin(t*6):Math.max(.25,1-age/1.6);
        ctx.fillStyle='rgba('+SR+','+al+')';ctx.beginPath();ctx.arc(bx,by,(b.live?4.5:3)*DPR,0,6.283);ctx.fill();
        if(age<1.2){ctx.strokeStyle='rgba('+SR+','+(1-age/1.2)*.7+')';ctx.beginPath();ctx.arc(bx,by,(3+age*18)*DPR,0,6.283);ctx.stroke();}
      });
      ctx.fillStyle='#F4F1EA';ctx.fillRect(cx-2*DPR,cy-2*DPR,4*DPR,4*DPR);
      if(on)raf=requestAnimationFrame(draw);
    }
    whileVisible(box,function(){if(!on){on=true;raf=requestAnimationFrame(draw);}},function(){on=false;cancelAnimationFrame(raf);});
    // Rows: slide in from the left under a clip as the list scrolls past, dates scramble.
    var seen=new WeakSet();
    function arm(){rows().forEach(function(row){if(seen.has(row))return;seen.add(row);
      row.style.clipPath='inset(0 100% 0 0)';
      onceVisible(row,afterTx(function(){
        row.animate([{clipPath:'inset(0 100% 0 0)',transform:'translateX(-18px)'},{clipPath:'inset(0 0% 0 0)',transform:'none'}],{duration:800,easing:E,fill:'forwards'}).finished.then(function(){row.style.clipPath='';row.getAnimations().forEach(function(a){a.cancel();});});
        var day=$('.ev__day',row),mon=$('.ev__mon',row);day&&scramble(day,null,380);mon&&scramble(mon,null,420);
      }));});}
    var list=$('[data-ev-list]',root); if(list){arm();new MutationObserver(arm).observe(list,{childList:true});}
  }

  /* ======================================================= 404 */
  function notFound(){
    if(!document.body.classList.contains('template-404'))return;
    var sec=$('main section'); if(!sec||sec._fxd)return; sec._fxd=1;
    var host=$('.wrap > div',sec); if(!host)return;
    sec.classList.add('fxd-404');
    // TV static behind everything, drawn small and scaled up for a chunky look, at about 12 fps.
    var nz=el('canvas','nz',null); sec.insertBefore(nz,sec.firstChild); nz.width=160; nz.height=100; var nx=nz.getContext('2d'), img=nx.createImageData(160,100), nt=0;
    // The mark: four chevrons and the core, each extruded as a stack of layers so it reads as a solid object.
    var CHEV='M-26.9,-39.6 L-18.8,-47.8 L0,-29 L18.8,-47.8 L26.9,-39.6 L0,-12.8 Z', L=9;
    var m3=el('div','fxd-m3',null); m3.setAttribute('aria-hidden','true');
    var rig=el('div','rig',m3), groups=[];
    for(var k=0;k<4;k++){
      var g=el('div','g',rig), h='';
      for(var i=0;i<L;i++){var front=i===L-1,shade=Math.round(34+i*5);
        h+='<svg viewBox="-50 -50 100 100" style="transform:translateZ('+((i-L+1)*1.8)+'px)"><path d="'+CHEV+'" transform="rotate('+(k*90)+')" fill="'+(front?'#F4F1EA':'rgb('+shade+','+(shade-2)+','+(shade-6)+')')+'"/></svg>';}
      g.innerHTML=h; groups.push(g);
    }
    var core=el('div','core',rig,''); for(var j=0;j<L;j++){var q=el('i','',core);q.style.transform='translateZ('+((j-L+1)*1.8)+'px)';}
    host.replaceWith(m3);
    var lab=$('.mono',sec); if(lab){var sigEl=el('span','fxd-sig',null,'No signal');lab.after(sigEl);}
    var btn=$('.btn',sec), tx=0, ty=0, rx=0, ry=0, spread=.55, want=.55, dragging=false, lastX=0, lastY=0, t0=performance.now();
    var parts=[0,1,2,3].map(function(){return {rz:(Math.random()-.5)*50,rx:(Math.random()-.5)*70,dz:(Math.random()-.5)*60};});
    function setWant(v){want=v; if(sigEl){scramble(sigEl,v<.1?'Signal acquired':'No signal',380);}}
    if(btn){btn.addEventListener('pointerenter',function(){setWant(0);});btn.addEventListener('pointerleave',function(){setWant(.55);});
      btn.addEventListener('focus',function(){setWant(0);});btn.addEventListener('blur',function(){setWant(.55);});
      btn.addEventListener('touchstart',function(){setWant(0);},{passive:true});}
    if(FINE)window.addEventListener('pointermove',function(e){tx=(e.clientX/window.innerWidth-.5)*2;ty=(e.clientY/window.innerHeight-.5)*2;});
    m3.addEventListener('pointerdown',function(e){dragging=true;lastX=e.clientX;lastY=e.clientY;m3.setPointerCapture&&m3.setPointerCapture(e.pointerId);setWant(.12);});
    m3.addEventListener('pointermove',function(e){if(!dragging)return;ry+=(e.clientX-lastX)*.6;rx-=(e.clientY-lastY)*.6;lastX=e.clientX;lastY=e.clientY;});
    m3.addEventListener('pointerup',function(){dragging=false;setWant(.55);});
    var on=false,raf=0,lastNz=0;
    function frame(now){
      var t=(now-t0)/1000;
      spread+=(want-spread)*.08;
      if(!dragging){
        var aimY=FINE?tx*32:Math.sin(t*.5)*30, aimX=FINE?-ty*22:Math.sin(t*.37)*14;
        ry+=(aimY-ry)*.06; rx+=(aimX-rx)*.06;
      }
      rig.style.transform='rotateX('+rx.toFixed(2)+'deg) rotateY('+ry.toFixed(2)+'deg)';
      groups.forEach(function(g,k){var p=parts[k],s=spread*(1+.12*Math.sin(t*1.3+k));
        g.style.transform='rotateZ('+(k*90)+'deg) translateY('+(-s*38).toFixed(2)+'px) translateZ('+(p.dz*s).toFixed(2)+'px) rotateX('+(p.rx*s).toFixed(2)+'deg) rotateZ('+(p.rz*s).toFixed(2)+'deg) rotateZ('+(-k*90)+'deg)';});
      core.style.transform='translateZ('+(spread*20*Math.sin(t*2)).toFixed(2)+'px) rotateZ('+(spread*45).toFixed(2)+'deg)';
      core.lastChild.style.background=spread<.06?SIG:'#fff';
      if(now-lastNz>80){lastNz=now;var d=img.data;for(var i=0;i<d.length;i+=4){var v=(Math.random()*255)|0;d[i]=d[i+1]=d[i+2]=v;d[i+3]=255;}
        // an occasional rolling bar, like a bad feed
        var bar=((t*40)%140|0)-20; for(var y=Math.max(0,bar);y<Math.min(100,bar+6);y++)for(var x=0;x<160;x++){var o2=(y*160+x)*4;d[o2]=d[o2+1]=d[o2+2]=230;}
        nx.putImageData(img,0,0);}
      if(on)raf=requestAnimationFrame(frame);
    }
    whileVisible(sec,function(){if(!on){on=true;raf=requestAnimationFrame(frame);}},function(){on=false;cancelAnimationFrame(raf);});
    if(lab)setInterval(function(){scramble(lab,null,420);},3200);
  }

  function boot(){
    if(REDUCE||!window.gsap||!window.ScrollTrigger||!Element.prototype.animate||!html.classList.contains('fx-on'))return;
    var st=document.createElement('style');st.id='fxd-css';st.textContent=CSS;document.head.appendChild(st);
    [shop,product,events,notFound,replayHeadlines].forEach(function(f){try{f();}catch(e){console.warn('[endex-depth]',f.name,e);}});
    ScrollTrigger.refresh();
  }
  // endex-fx.js boots on DOMContentLoaded; wait a tick so its globals (card fade-ins, fx-on) are in place first.
  function go(){setTimeout(boot,0);}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',go):go();
  document.addEventListener('shopify:section:load',function(){setTimeout(function(){try{shop();product();events();}catch(e){}},0);});
})();
